"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportBannersComparison = void 0;
var tslib_1 = require("tslib");
var web_bi_logger_1 = require("@wix/web-bi-logger");
var v2_1 = require("@wix/bi-logger-dealer-marketing-banners/v2");
var logger = web_bi_logger_1.default.factory().logger();
function reportBannersComparison(dealerServingResponse, dealerBannersResponse, isError) {
    if (dealerServingResponse === void 0) { dealerServingResponse = {}; }
    if (dealerBannersResponse === void 0) { dealerBannersResponse = {}; }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var bannersPayload, servingPayload, e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    bannersPayload = JSON.stringify(dealerBannersResponse);
                    servingPayload = JSON.stringify(dealerServingResponse);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, logger.report(v2_1.dealerComparisonDebugNewService({
                            bannersPayload: '',
                            dealerBannersOfferId: dealerBannersResponse.lightboxGuid,
                            dealerBannersTemplateId: dealerBannersResponse.bannerId,
                            dealerServingOfferId: dealerServingResponse.lightboxGuid,
                            dealerServingTemplateId: dealerServingResponse.bannerId,
                            isEqual: bannersPayload === servingPayload,
                            isError: isError,
                            isOfferIdEqual: dealerServingResponse.lightboxGuid ===
                                dealerBannersResponse.lightboxGuid,
                            isTemplateIdEqual: dealerServingResponse.bannerId === dealerBannersResponse.bannerId,
                            servingPayload: '',
                            realEstateId: dealerBannersResponse.bannerPosition,
                        }))];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.reportBannersComparison = reportBannersComparison;
//# sourceMappingURL=index.js.map